import {Locale} from 'date-fns';
import {enUS, nl, fr} from 'date-fns/locale';

export const systemDateFormat = 'yyyy-MM-dd';
export const storageKeys = {
  deprecated: {
    // Used for cleanup purposes
    selectedBuildingKey: 'selectedBuildingId',
    selectedFloorKey: 'selectedFloorId',
    selectedAreaKey: 'selectedAreaId',
    isNotificationPermissionRequestedKey: 'isNotificationPermissionRequested',
  },
  current: {
    lastSelectedWorkspaceReservationLocation: 'lastSelectedShiftLocation',
    wasDeskBookingOnboardingShownKey: 'isDeskBookingIntroShown',
    wasUserOnboardedToNotificationsKey: 'wasUserOnboardedToNotifications',
    hasUserClosedPushNotificationReminderKey: 'hasUserClosedPushNotificationReminder',
    swiftConnectRefreshToken: 'swiftConnectRefreshToken',
  },
};
export type AppLanguage = 'en' | 'nl' | 'fr';
export const fallbackLanguage: AppLanguage = 'en';
export const knownLocales: {[key: string]: Locale} = {
  en: enUS,
  nl: nl,
  fr: fr,
};

export const LATEST_MAP_RENDERER_VERSION = 3;

export const RESERVATION_STATUS = {
  Confirmed: 'Confirmed',
  InvitationPending: 'InvitationPending',
  InvitationDeclined: 'InvitationDeclined',
  InvitationExpired: 'InvitationExpired',
  InvitationCancelled: 'InvitationCancelled',
  InvitationOverwritten: 'InvitationOverwritten',
} as const;
